module.exports = __webpack_public_path__ + "img/pos_logo.d9b9bdf5.jpg";